<div class="editForm" [ngSwitch]="typeOf">
  <edit-c-cta
    *ngSwitchCase="'cta'"
    [cta]="typeOf"
    [rowType]="rowType"
    [rowArray]="rowArray"
    [compArray]="compArray"
    [template]="template"
    [edit]="edit"
    [defaultColors]="colors"
    [starterTheme]="starterTheme"
  ></edit-c-cta>
  <edit-c-embed
    *ngSwitchCase="'embed'"
    [rowType]="rowType"
    [rowArray]="rowArray"
    [compArray]="compArray"
    [template]="template"
    [edit]="edit"
  ></edit-c-embed>
  <edit-c-feedback
    *ngSwitchCase="'feedback'"
    [feed]="typeOf"
    [rowType]="rowType"
    [rowArray]="rowArray"
    [compArray]="compArray"
    [template]="template"
    [edit]="edit"
  ></edit-c-feedback>
  <edit-c-image
    *ngSwitchCase="'image'"
    [image]="typeOf"
    [rowType]="rowType"
    [rowArray]="rowArray"
    [compArray]="compArray"
    [template]="template"
    [edit]="edit"
    [defaultColors]="colors"
    [starterTheme]="starterTheme"
  ></edit-c-image>
  <ag-edit-c-showcase
    *ngSwitchCase="'showcase'"
    [isPopularList]="false"
    class="show"
    [show]="typeOf"
    [rowType]="rowType"
    [rowArray]="rowArray"
    [compArray]="compArray"
    [template]="template"
    [edit]="edit"
    [dynamic]="dynamic"
    [defaultColors]="colors"
    [starterTheme]="starterTheme"
    [widgetEdit]="widgetEdit"
  ></ag-edit-c-showcase>
  <ag-edit-c-showcase
    *ngSwitchCase="'showcase-list'"
    [isPopularList]="false"
    class="show"
    [show]="typeOf"
    [rowType]="rowType"
    [rowArray]="rowArray"
    [compArray]="compArray"
    [template]="template"
    [edit]="edit"
    [dynamic]="dynamic"
    [starterTheme]="starterTheme"
    [defaultColors]="colors"
  ></ag-edit-c-showcase>
  <ag-edit-c-showcase
    *ngSwitchCase="'popular-list'"
    [isPopularList]="true"
    class="show"
    [show]="typeOf"
    [rowType]="rowType"
    [rowArray]="rowArray"
    [compArray]="compArray"
    [template]="template"
    [edit]="edit"
    [dynamic]="dynamic"
    [defaultColors]="colors"
    [starterTheme]="starterTheme"
  ></ag-edit-c-showcase>
  <edit-c-text
    *ngSwitchCase="'text'"
    [textBlock]="typeOf"
    [rowType]="rowType"
    [rowArray]="rowArray"
    [compArray]="compArray"
    [template]="template"
    [edit]="edit"
  ></edit-c-text>
  <edit-c-topic
    *ngSwitchCase="'topic'"
    class="topic"
    [topic]="typeOf"
    [rowType]="rowType"
    [rowArray]="rowArray"
    [compArray]="compArray"
    [template]="template"
    [edit]="edit"
  ></edit-c-topic>
  <edit-customer-care
    *ngSwitchCase="'customerCare'"
    class="topic"
    [typeOf]="typeOf"
    [rowType]="rowType"
    [rowArray]="rowArray"
    [compArray]="compArray"
    [template]="template"
    [edit]="edit"
  ></edit-customer-care>

  <div *ngSwitchDefault class="empty-component">
    <i class="fa fa-ban" aria-hidden="true"></i>
    <div>Were sorry there seems a different option than what you have chosen.</div>
    <input
      class="form-control"
      [(ngModel)]="empty"
      placeholder="Send us a message"
      title="Send us a message"
    />
    <button
      role="button"
      type="button"
      aria-label="Send Message"
      class="btn btn-outline-primary"
      [disabled]="!empty"
    >
      Go
    </button>
  </div>
</div>
